import { Alignment, PrimaryButton, Stack, useTheme } from '@fluentui/react';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { IEventItem } from '../../../Models/Event/IEventItem';
import {dateToCZTimeStr} from "../../../Tools/DateTime";

interface IOrderButtonProps {
    event: IEventItem;
    center: Alignment
}


export const OrderButton: React.FunctionComponent<IOrderButtonProps> = (props) => {

    const navigate = useNavigate()
    const theme = useTheme();

    const renderButtom = (item: IEventItem) => {

        let registrationDate = new Date(item.registrationStart);
        registrationDate.setHours(item.registrationTime.getHours());
        registrationDate.setMinutes(item.registrationTime.getMinutes());
        
        if (registrationDate > new Date(Date.now())) {
            if (registrationDate.getDate() === new Date(Date.now()).getDate()) {
                return <Stack horizontalAlign={props.center} wrap styles={{ root: { color: theme.palette.green } }}>registrace dnes v <span>{dateToCZTimeStr(registrationDate)}</span></Stack>
            } else {
                return <Stack horizontalAlign={props.center} wrap styles={{ root: { color: theme.palette.green } }}>registrace od <span>{registrationDate.toLocaleDateString("cs-CZ")}</span><span>v {dateToCZTimeStr(registrationDate)}</span></Stack>
            }
        }
        var desc = null;
        if ((item.seets - item.seetsTaken) > 4) {
            return <Stack horizontalAlign={props.center}><PrimaryButton text="Objednat" styles={{ root: { width: 100 } }} onClick={() => { window.location.href =`/events/order?eventId=${item.id}` }} /></Stack>
        }

        if (((item.seets - item.seetsTaken) <= 4) && (item.seets - item.seetsTaken) > 0) {
            return <>
                <Stack horizontalAlign={props.center}><PrimaryButton text="Objednat" styles={{ root: { width: 100 } }} onClick={() => {window.location.href =`/events/order?eventId=${item.id}` }} /></Stack>
                <Stack horizontalAlign={props.center} styles={{ root: { color: theme.palette.red } }}>poslední {(item.seets - item.seetsTaken)} místa</Stack>
            </>
        }

        if ((item.seets - item.seetsTaken) <= 0 && (item.substitutes - item.substitutesTaken) > 0) {
            return <>
                <Stack horizontalAlign={props.center}><PrimaryButton text="Objednat" styles={{ root: { width: 100 } }} onClick={() => { window.location.href =`/events/order?eventId=${item.id}` }} /></Stack>
                <Stack horizontalAlign={props.center} styles={{ root: { color: theme.palette.red } }}>jako náhradník</Stack>
            </>
        }
        else {
            return <Stack horizontalAlign={props.center}><PrimaryButton disabled text="Obsazeno" styles={{ root: { width: 100 } }} /></Stack>
        }
        return null;
    }

    return (renderButtom(props.event))
}
